export default class RouterCredModel {
  devicekey = '';

  constructor(data) {
    if (!data) return;
    this.devicekey = data.devicekey;
  }
}
